import React from 'react';
import Select from 'react-select';

type DataProps = {
  value: string;
  label: string;
};

type Props = {
  isLoading?: boolean;
  isDisabled?: boolean;
  options: any;
  name: string;
  onChange: (value: DataProps) => void;
  value: any;
  placeholder: string;
  isClearable?: boolean;
}

const SelectWithSearch = ({
  isDisabled,
  isLoading,
  options,
  name,
  onChange,
  value,
  placeholder,
  isClearable = false
}: Props) => {
  return (
    <Select
      className="basic-single"
      classNamePrefix="select"
      isDisabled={isDisabled}
      isLoading={isLoading}
      isSearchable={true}
      name={name}
      options={options}
      placeholder={placeholder}
      onChange={onChange}
      menuPortalTarget={document.body}
      menuPosition={'fixed'}
      noOptionsMessage={() => 'Sem resultados.'}
      value={value}
      loadingMessage={() => 'Carregando...'}
      isClearable={isClearable}
      styles={{ 
        menuPortal: (provided: any) => ({ 
          ...provided,
          zIndex: 9999
        }) }}
    />
  )
}

export default SelectWithSearch;